import { useToast } from '@/lib/notifications';
import { MESSAGE_INTERROMPUE } from '@/lib/use-interruption';
import { useNavigate } from '@tanstack/react-router';
import { useEffect, useRef } from 'react';

/**
 * A translation that was interrupted (#7), opened at the address of its result or of its
 * analysis (a bookmark, another tab, another person): the toast that says so (it survives
 * the route change, its provider is at the root), then the history, where its card H7 offers
 * "relancer" and "écarter".
 */
export function RedirectionInterrompue() {
  const navigate = useNavigate();
  const { afficher } = useToast();
  // Strict mode runs an effect twice on mount: the toast must still be shown once.
  const fait = useRef(false);

  useEffect(() => {
    if (fait.current) return;
    fait.current = true;
    afficher({ variant: 'neutre', message: MESSAGE_INTERROMPUE });
    void navigate({ to: '/historique', replace: true });
  }, [afficher, navigate]);

  return null;
}
